module.exports = new __parcel__URL__("OKXLogo.c4036e07.png").toString();